import FileUpload from "components/FileUpload";
import { useAuth } from "context/AuthContext";
import { useTooltip } from "context/TooltipProvider";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { addAppeal } from "services/complaintDetailService";
import { Appeal } from "types";
import { errorHandlerOnForm } from "utils/helper";
import FormInput, { FormTextArea } from "../FormInput";

const defaultData: Appeal = {
  id: undefined,
  parent_appeal_id: undefined,
  appeal_document: null,
  resolution_file: null,
  status: "pending",
  appeal_date: undefined,
  lower_org_unit: "",
  lower_admin_unit: "",
  appeal_summary: "",
  resolution_text: "",
  resolution_date: undefined,
  resolved_by: "",
  resolved_by_user_id: "",
  admin_unit_id: "",
  org_unit_id: "",
  departement_id: "",
  parent_appeal: undefined,
};

const AppealRequest: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginData } = useAuth();
  const { showTooltip } = useTooltip();

  const [formState, setFormState] = useState<Appeal>(defaultData);

  // File handlers
  const handleFileChange = (name: string, file: File | null) => {
    setFormState((prev) => ({
      ...prev,
      [name]: file,
    }));
  };

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value, type } = e.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: type === "number" ? Number(value) : value,
    }));
  };

  const validateForm = () => {
    if (!location?.state?.complaint_id && !location?.state?.appeal)
      return "Complaint ID is Required.";
    if (!formState.appeal_summary) return "Appeal Summary is Required.";
    if (!formState.appeal_date) return "Appeal Date is Required.";
    return "";
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    const error = validateForm();
    if (error) {
      showTooltip(error, "error");
      return;
    }

    const complaint_id = location?.state?.complaint_id
      ? location?.state?.complaint_id
      : location?.state?.appeal
        ? undefined
        : formState.complaint_id;

    addAppeal({
      ...formState,
      status: "pending",
      resolved_by_user_id: loginData?.user_id,
      resolved_by: loginData?.full_name,
      org_unit_id: loginData?.org_unit,
      admin_unit_id: loginData?.admin_unit,
      departement_id: loginData?.structure?.org_unit?.uu_id,
      // lower_org_unit: loginData?.lower_org_unit,
      // lower_admin_unit: loginData?.lower_admin_unit,
      complaints: complaint_id,
      complaint_id: complaint_id,
      parent_appeal_id: location?.state?.appeal?.id,
      parent_appeal: location?.state?.appeal?.id,
    })
      .then((data) => {
        showTooltip("Successfully Submitted!", "success");
        navigate(-1);
      })
      .catch((err) => {
        showTooltip(errorHandlerOnForm(err?.response?.data), "error");
      });
  };

  return (
    <div className="max-w-screen-xl ml-1 mr-4 space-y-6">
      <form onSubmit={handleSubmit}>
        <div className="bg-white shadow-xl rounded-lg p-6 mt-4 ">
          <span className="text-[24px] font-semibold ">
            Register New Appeal
          </span>

          <div className="grid grid-cols-2 gap-4 mt-4">
            <FormInput
              label="Appeal Date"
              type="date"
              value={
                formState.appeal_date
                  ? new Date(formState.appeal_date).toISOString().split("T")[0]
                  : ""
              }
              onChange={handleChange}
              name="appeal_date"
            />
            <FormInput
              label="Resolution Date"
              type="date"
              value={
                formState.resolution_date
                  ? new Date(formState.resolution_date)
                      .toISOString()
                      .split("T")[0]
                  : ""
              }
              onChange={handleChange}
              name="resolution_date"
            />
          </div>

          <div className="flex flex-col gap-4 mt-4">
            <FormTextArea
              label="Appeal Claim Summary"
              value={formState.appeal_summary || ""}
              onChange={handleChange}
              name="appeal_summary"
              placeholder="Enter appeal summary"
              rows={4}
            />
            <FormTextArea
              label="Lower Administration Unit Resolution"
              value={formState.resolution_text || ""}
              onChange={handleChange}
              name="resolution_text"
              placeholder="Enter resolution text"
              rows={4}
            />
            <FileUpload
              label="Appeal Claim Document"
              fileTypes="*"
              info="Upload Files"
              required={false}
              onChange={(file) => handleFileChange("appeal_document", file)}
            />
            <FileUpload
              label="Lower Administration Unit Resolution Document "
              fileTypes="*"
              info="Upload Files"
              required={false}
              onChange={(file) => handleFileChange("resolution_file", file)}
            />
          </div>
          <div className="flex flex-row mt-4 gap-3">
            <input
              type="reset"
              className="border border-[#212121] px-[76px] py-3 text-[#747474]  cursor-pointer font-[500] text-base rounded-md hover:bg-[#D4D4D4]"
              value={"Cancel"}
            />
            <input
              type="submit"
              className="border border-[#212121] bg-[#212121] px-[76px] py-3 text-white  cursor-pointer font-[500] text-base rounded-md hover:bg-[#414040]"
              value={"Submit Appeal"}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default AppealRequest;
